export default "__VITE_ASSET__g6kR$usb__"